var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1H0.5V8V11.5429L3.95711 15H7.5H14.5V1Z",
    stroke: "#FAE232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5L6.5 10L12 4.5",
    stroke: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFilled);
export default __webpack_public_path__ + "static/media/checkbox_filled.c6f12b14ada19a398b8bcacbb55a4a62.svg";
export { ForwardRef as ReactComponent };